module.exports = __webpack_public_path__ + "shallow_r.358a2340.png";